import React, { useState, useEffect } from "react";
import _ from "lodash";
import { data_fetch_api_resource } from "../../utils/http_functions";
import { i18n } from "../../config";

import { MenuItem, Select, FormControl, InputLabel, FormHelperText } from "@mui/material";

const ContractSelectField = ({ input: { onChange, value }, initialValue, label, readOnly, onAvailableItemsUpdate, onSelectUpdate, gas, power, meta, ...rest }) => {

  const [availableItems, setAvailableItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");

  const fetchAvailableItems = async () => {
    const endpoint = "contracts?limit=99999&offset=0";  //TODO: Això s'ha de canviar, has de posar un input autocomplete searchable, i que aquest tingui paginacio.
    const response = await data_fetch_api_resource(null, endpoint, 2);
    if (response.status === 200) {
      const { items } = response.data;

      setAvailableItems(items);

      if (items && typeof onAvailableItemsUpdate === "function") {
        onAvailableItemsUpdate();
      }

      let defaultSelectedItem;
      if (value) {
        defaultSelectedItem = value;
        setSelectedItem(defaultSelectedItem);
        onChange(defaultSelectedItem);
      }
    }
  };

  const handleChange = (event, index, value) => {
    setSelectedItem(event.target.value);
    onChange(event.target.value);
    if (typeof onSelectUpdate === "function") {
      onSelectUpdate(event.target.value, index.props.children);
    }
  };

  useEffect(() => {
    fetchAvailableItems();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <FormControl fullWidth={true}
        disabled={readOnly}
      >
        <InputLabel shrink htmlFor="">
          {(label || i18n.t('common:text.contact_contract')) + "*"}
        </InputLabel>
        <Select
          value={selectedItem}
          onChange={handleChange}
          autoWidth={false}
          {...rest}
        >
          {(!_.isEmpty(availableItems) &&
            availableItems.map((c) => {
              return <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>;
            })) ||
            []}
        </Select>
      </FormControl>
      {!!(meta.touched) &&
        <FormHelperText error={true}>
          {meta.error}
        </FormHelperText>
      }
    </div>
  );
};

export default ContractSelectField;
